import SeoMeta from 'components/Basic/Head/SeoMeta';
import { CookieConsentPage } from 'components/Pages/CookieConsent/CookieConsentPage';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import { useGtmStaticPageView } from 'hooks/gtm/useGtmStaticPageView';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { NextPageExtended } from 'types/global';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';
import { useGtmStaticPageViewEvent } from 'utils/Gtm/EventFactories';

const UserConsentPage: NextPageExtended<ServerSidePropsType> = () => {
    const { t } = useTranslation();
    const { url: domainUrl } = useDomainConfig();
    const [cookieConsentUrl] = getInternationalizedStaticUrls(['/cookie-consent'], domainUrl);
    const breadcrumbs = useMemo(() => [{ name: t('Cookie consent'), slug: cookieConsentUrl }], [cookieConsentUrl, t]);
    const gtmStaticPageViewEvent = useGtmStaticPageViewEvent('cookie consent', breadcrumbs);
    useGtmStaticPageView(gtmStaticPageViewEvent);

    return (
        <>
            <SeoMeta title={t('Cookie consent update')} />
            <CookieConsentPage breadcrumbs={breadcrumbs} />
        </>
    );
};

export const getServerSideProps = getServerSidePropsWrapper(({ domainConfig, redisClient, t }) => async (context) => {
    return initServerSideProps({ context, domainConfig, redisClient, t });
});

export default UserConsentPage;
